import classNames from 'classnames'
import React from 'react'
import Container from './container'
import Ctas from './ctas'
import Grid from './grid'
import Logos from './logos'
import Media from './media'
import Social from './social'

export default function Hero({ text, links, media, design }) {
  const { kicker, heading, description } = text ?? {}
  const { ctas, social } = links ?? {}
  const { background, foreground, logos } = media ?? {}
  const { theme } = design ?? { theme: 'dark' }

  return (
    <section
      className={classNames(
        'relative',
        {
          light: 'bg-primary text-secondary',
          dark: 'bg-secondary text-primary'
        }[theme]
      )}>
      <Media
        className="absolute left-0 top-0 h-full w-full"
        autoPlay
        preload="auto"
        muted
        loop
        cover
        playsInline
        {...background}
      />
      {(background?.image || background?.video) && (
        <div className="absolute inset-0 bg-black/50" />
      )}

      <div className="relative z-20">
        <Container className="pb-8 pt-16 lg:pb-16 lg:pt-36">
          <Grid className="lg:items-center">
            <div
              className={classNames(
                'col-span-12',
                background?.image || background?.video
                  ? 'md:col-span-6 lg:col-span-7'
                  : 'md:col-span-6 lg:col-span-5'
              )}>
              {kicker && (
                <div
                  className="accent-lg"
                  dangerouslySetInnerHTML={{
                    __html: kicker.replaceAll(
                      /\*(?<em>.*?)\*/g,
                      '<span class="emphasis">$<em></span>'
                    )
                  }}
                />
              )}
              {heading && (
                <h1
                  className={classNames(
                    heading.length > 40
                      ? 'heading-3xl mt-4'
                      : 'heading-5xl mt-4'
                  )}>
                  {heading}
                </h1>
              )}
              {social && (
                <div className="my-6">
                  <Social {...social} />
                </div>
              )}
              {description && (
                <div
                  className="body-lg hero-prose my-4"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {ctas?.buttons && (
                <div className="mt-8">
                  <Ctas
                    color={{ dark: 'white', light: 'black' }[theme]}
                    size="lg"
                    {...ctas}
                  />
                </div>
              )}
            </div>
            {(foreground?.image || foreground?.video) && (
              <div className="col-span-12 md:col-span-6 lg:col-span-5 lg:col-start-8">
                <div className="rounded-xxx border-secondary relative w-full transform-gpu overflow-hidden border-2">
                  <Media autoPlay preload="auto" muted loop {...foreground} />
                </div>
              </div>
            )}
          </Grid>
        </Container>
        <Container className="pb-16">
          {logos && <Logos size="lg" {...logos} />}
        </Container>
      </div>
    </section>
  )
}
